import { createPaginationWatcher } from '../common/store/comments/paging/comments-paging-watcher';
import { createTranslationsWatcher } from '../common/store/translations/translations-watcher';
import { createRatingsWatcher } from '../common/store/comments/ratings/ratings-watcher';
export const createCommentsControllerApi = ({ actions, devToolsApi, store, shouldAutoBindStateToSetProps, commentsWatcherConfig, bindStateToSetProps, beforeCreateInterceptor, }) => {
    return {
        fetchComments: ({ resourceId, ctxFields, pagination, withVotes = false, withRatings = false, }) => actions &&
            actions.wcActions.fetchComments({
                resourceId,
                ctxFields,
                pagination,
                withVotes: resolveVotesWithDevState({
                    withVotes,
                    reactionsDevState: devToolsApi.getState().commentReactions,
                }),
                withRatings: resolveRatingsWithDevState({
                    withRatings,
                    ratingsDevState: devToolsApi.getState().ratings,
                }),
            }),
        bulkFetchComments: (payload) => actions &&
            actions.wcActions.bulkFetchComments(payload.map(({ resourceId, ctxFields, pagination, withVotes = false, withRatings = false }) => ({
                resourceId,
                ctxFields,
                pagination,
                withVotes: resolveVotesWithDevState({
                    withVotes,
                    reactionsDevState: devToolsApi.getState().commentReactions,
                }),
                withRatings: resolveRatingsWithDevState({
                    withRatings,
                    ratingsDevState: devToolsApi.getState().ratings,
                }),
            }))),
        fetchDeepLink: ({ commentId, resourceId, pagination, withVotes = false, withRatings = false, ctxFields, }) => actions &&
            actions.wcActions.fetchDeepLink({
                ctxFields,
                resourceId,
                pagination,
                commentId,
                withVotes: resolveVotesWithDevState({
                    withVotes,
                    reactionsDevState: devToolsApi.getState().commentReactions,
                }),
                withRatings: resolveRatingsWithDevState({
                    withRatings,
                    ratingsDevState: devToolsApi.getState().ratings,
                }),
            }),
        permissionsChangedExternally: () => {
            actions && actions.wcActions.refetchCommentsData();
        },
        bindStateToSetProps: shouldAutoBindStateToSetProps
            ? () => console.error('Please set `shouldAutoBindStateToSetProps` to `false` if you need to use `bindStateToSetProps`')
            : bindStateToSetProps,
        watch: {
            pagination: createPaginationWatcher(store),
            translations: createTranslationsWatcher(store),
            comments: commentsWatcherConfig.createWatcher(store),
            ratings: createRatingsWatcher(store),
        },
        intercept: {
            onBeforeCrud: beforeCreateInterceptor.onBeforeCrud,
        },
        affect: {
            tryOpenCommentBox: (resourceId, options) => actions && actions.wcActions.tryOpenCommentBox({ resourceId, ...options }),
            tryCloseAllCommentBoxes: (resourceId) => actions && actions.wcActions.tryCloseAllCommentBoxes({ resourceId }),
        },
        unmountAllResources: () => actions && actions.wcActions.unmountAllResources(),
    };
};
const resolveVotesWithDevState = ({ withVotes, reactionsDevState, }) => {
    return reactionsDevState === 'auto' ? withVotes : reactionsDevState === 'votes' ? true : false;
};
const resolveRatingsWithDevState = ({ withRatings, ratingsDevState, }) => {
    return ratingsDevState.type === 'auto'
        ? withRatings
        : ratingsDevState.type === 'on'
            ? true
            : false;
};
//# sourceMappingURL=create-comments-controller-api.js.map